import { StoreStateUi } from "../types/loginTypes";

let storeKey = 'stackbase';

export function getUiState(state: any): StoreStateUi {
    return state[storeKey];
}

export function setStoreKey(key: string) {
    storeKey = key;
}
